import React, { useState } from 'react';

const AllianceTab = ({ allianceData, t }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try { await navigator.clipboard.writeText(text); }
    catch { const ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!allianceData) {
    return (
      <div className="text-center" style={{ padding: '60px 20px' }}>
        <img src="/bobine-face-splash.png" alt="" style={{ width: 48, animation: 'bobine-spin 4s linear infinite', opacity: 0.3 }} />
      </div>
    );
  }

  return (
    <div data-testid="alliance-tab-content" style={{ maxWidth: 600, margin: '0 auto' }}>
      {/* Header */}
      <div className="text-center" style={{ marginBottom: 32 }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%', margin: '0 auto 16px',
          backgroundColor: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
          </svg>
        </div>
        <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 22, color: '#D4AF37', fontWeight: 400, margin: '0 0 8px' }}>
          {t('alliance_title')}
        </h3>
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0', fontStyle: 'italic' }}>
          {t('alliance_subtitle')}
        </p>
      </div>

      {/* Referral Code Card */}
      <div style={{
        border: '1px solid rgba(212,175,55,0.2)', borderRadius: 14, padding: '24px',
        backgroundColor: 'rgba(212,175,55,0.02)', marginBottom: 20,
      }}>
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 10 }}>
          {t('alliance_your_code')}
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
          <span data-testid="alliance-code" style={{
            fontFamily: "'Georgia', serif", fontSize: 22, color: '#D4AF37', fontWeight: 600,
            letterSpacing: 3, flex: 1,
          }}>
            {allianceData.referral_code}
          </span>
          <button
            data-testid="alliance-copy-code"
            onClick={() => copyToClipboard(allianceData.referral_code)}
            style={{
              fontFamily: "'Georgia', serif", fontSize: 12, padding: '6px 16px', borderRadius: 6,
              backgroundColor: copied ? 'rgba(39,174,96,0.1)' : 'rgba(212,175,55,0.08)',
              border: copied ? '1px solid rgba(39,174,96,0.3)' : '1px solid rgba(212,175,55,0.2)',
              color: copied ? '#27ae60' : '#D4AF37', cursor: 'pointer', transition: 'all 0.3s',
            }}
          >
            {copied ? t('alliance_copied') : t('alliance_copy')}
          </button>
        </div>

        {/* Share link */}
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 8 }}>
          {t('alliance_share_link')}
        </p>
        <div style={{
          padding: '10px 14px', borderRadius: 8, backgroundColor: 'rgba(212,175,55,0.04)',
          border: '1px solid rgba(212,175,55,0.1)', marginBottom: 16,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          <span data-testid="alliance-share-url" style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0' }}>
            {allianceData.share_url}
          </span>
        </div>

        {/* Action buttons */}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <button
            data-testid="alliance-copy-link"
            onClick={() => copyToClipboard(allianceData.share_url)}
            style={{
              fontFamily: "'Georgia', serif", fontSize: 13, padding: '10px 24px', borderRadius: 8,
              background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000', border: 'none', cursor: 'pointer',
              fontWeight: 600, transition: 'all 0.3s', flex: 1, minWidth: 140,
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: 'inline', verticalAlign: 'middle', marginRight: 6 }}>
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
            </svg>
            {copied ? t('alliance_copied') : t('alliance_copy')}
          </button>
          <button
            data-testid="alliance-share-whatsapp"
            onClick={() => {
              const text = `${t('alliance_share_text')} ${allianceData.share_url}`;
              window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
            }}
            style={{
              fontFamily: "'Georgia', serif", fontSize: 13, padding: '10px 24px', borderRadius: 8,
              backgroundColor: 'rgba(37,211,102,0.1)', color: '#25D366', border: '1px solid rgba(37,211,102,0.3)',
              cursor: 'pointer', fontWeight: 600, transition: 'all 0.3s', flex: 1, minWidth: 140,
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ display: 'inline', verticalAlign: 'middle', marginRight: 6 }}>
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
              <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/>
            </svg>
            WhatsApp
          </button>
        </div>
      </div>

      {/* How it works */}
      <div style={{
        border: '1px solid rgba(212,175,55,0.12)', borderRadius: 14, padding: '24px',
        backgroundColor: 'rgba(212,175,55,0.01)', marginBottom: 20,
      }}>
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', fontWeight: 600, marginBottom: 16, letterSpacing: 0.5 }}>
          {t('alliance_how_title')}
        </p>
        {[
          { num: '1', text: t('alliance_step1') },
          { num: '2', text: t('alliance_step2') },
          { num: '3', text: t('alliance_step3') },
        ].map((step) => (
          <div key={step.num} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 12 }}>
            <span style={{
              width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
              backgroundColor: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', fontWeight: 600,
            }}>{step.num}</span>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0', lineHeight: 1.6, margin: '4px 0 0' }}>
              {step.text}
            </p>
          </div>
        ))}
      </div>

      {/* Bonus status */}
      <div style={{
        padding: '14px 20px', borderRadius: 10, marginBottom: 20,
        backgroundColor: allianceData.referral_bonus_used ? 'rgba(39,174,96,0.06)' : 'rgba(212,175,55,0.04)',
        border: `1px solid ${allianceData.referral_bonus_used ? 'rgba(39,174,96,0.2)' : 'rgba(212,175,55,0.15)'}`,
        display: 'flex', alignItems: 'center', gap: 10,
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={allianceData.referral_bonus_used ? '#27ae60' : '#D4AF37'} strokeWidth="2">
          {allianceData.referral_bonus_used
            ? <><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>
            : <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>
          }
        </svg>
        <span style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: allianceData.referral_bonus_used ? '#27ae60' : '#FAF3E0' }}>
          {allianceData.referral_bonus_used ? t('alliance_bonus_used') : t('alliance_bonus_available')}
        </span>
      </div>

      {/* My referrals */}
      <div style={{
        border: '1px solid rgba(212,175,55,0.12)', borderRadius: 14, padding: '24px',
        backgroundColor: 'rgba(212,175,55,0.01)',
      }}>
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', fontWeight: 600, marginBottom: 16, letterSpacing: 0.5 }}>
          {t('alliance_my_referrals')} ({allianceData.total_referrals})
        </p>
        {allianceData.referrals.length === 0 ? (
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0', fontStyle: 'italic' }}>
            {t('alliance_no_referrals')}
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {allianceData.referrals.map((ref, i) => (
              <div key={i} data-testid={`referral-item-${i}`} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px 16px', borderRadius: 10,
                backgroundColor: 'rgba(212,175,55,0.03)', border: '1px solid rgba(212,175,55,0.08)',
              }}>
                <div>
                  <p style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', fontWeight: 600, margin: 0 }}>
                    {ref.name}
                  </p>
                  <p style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0', margin: '2px 0 0' }}>
                    {ref.joined_at ? new Date(ref.joined_at).toLocaleDateString('fr-FR') : ''}
                  </p>
                </div>
                <span style={{
                  fontFamily: "'Georgia', serif", fontSize: 11, padding: '4px 12px', borderRadius: 20,
                  backgroundColor: ref.bonus_given ? 'rgba(39,174,96,0.1)' : 'rgba(212,175,55,0.08)',
                  color: ref.bonus_given ? '#27ae60' : '#D4AF37',
                  border: `1px solid ${ref.bonus_given ? 'rgba(39,174,96,0.2)' : 'rgba(212,175,55,0.15)'}`,
                }}>
                  {ref.bonus_given ? t('alliance_status_active') : t('alliance_status_pending')}
                </span>
              </div>
            ))}
          </div>
        )}
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0', marginTop: 14, fontStyle: 'italic', textAlign: 'center' }}>
          {t('alliance_one_bonus_note')}
        </p>
      </div>
    </div>
  );
};

export default AllianceTab;
